import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/e468a762cbf2c4de3f207872d8ecdaa7/249121c6a7dc8fcc1d538c9d07722d0f.png"
              alt="VE Goodies"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('locations')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Locations
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              FAQ
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:from-orange-600 hover:to-orange-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Get Free Quote
          </button>
        </div>
      </div>
    </nav>
  );
}
